var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6669 11.78V13.78C14.6677 13.9657 14.6297 14.1494 14.5553 14.3195C14.4809 14.4897 14.3718 14.6424 14.235 14.7679C14.0982 14.8934 13.9367 14.989 13.7608 15.0485C13.5849 15.1079 13.3985 15.13 13.2136 15.1133C11.1622 14.8904 9.19161 14.1894 7.46028 13.0667C5.8495 12.0431 4.48384 10.6774 3.46028 9.06665C2.3336 7.32745 1.63244 5.34731 1.41361 3.28665C1.39695 3.10229 1.41886 2.91649 1.47795 2.74107C1.53703 2.56564 1.63199 2.40444 1.75679 2.26773C1.88159 2.13102 2.03348 2.02179 2.20281 1.947C2.37213 1.87221 2.55517 1.83349 2.74028 1.83332H4.74028C5.06382 1.83013 5.37748 1.9447 5.62279 2.15567C5.8681 2.36664 6.02833 2.65961 6.07361 2.97998C6.15803 3.62003 6.31458 4.24847 6.54028 4.85332C6.62998 5.09193 6.64939 5.35126 6.59622 5.60057C6.54305 5.84988 6.41952 6.07872 6.24028 6.25998L5.39361 7.10665C6.34265 8.77568 7.72458 10.1576 9.39361 11.1067L10.2403 10.26C10.4215 10.0807 10.6504 9.95722 10.8997 9.90405C11.149 9.85088 11.4083 9.87029 11.6469 9.95998C12.2518 10.1857 12.8802 10.3422 13.5203 10.4267C13.8441 10.4723 14.1399 10.6355 14.3513 10.885C14.5627 11.1345 14.6751 11.453 14.6669 11.78Z",
    stroke: "#FFA54C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone11);
export default __webpack_public_path__ + "static/media/phone11.c6de42f614fc1f21a440b74ec42e1ddb.svg";
export { ForwardRef as ReactComponent };